import Box from '@mui/material/Box'

export default function HighlightBox({ children }) {
    return (
        <Box sx={{ color: '#43454a', background: '#eaf2ff', borderRadius: '20px' }}>
            {children}
        </Box>
    )
}
